var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGetAutomatedBasedOrderStatus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_279_3543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.7625 27.45C54.7625 12.375 42.5125 0.125 27.45 0.125C12.3875 0.125 0.125 12.375 0.125 27.45C0.125 42.525 12.3875 54.775 27.45 54.775C42.5125 54.775 54.7625 42.5125 54.7625 27.45ZM27.45 50.2125C14.9 50.2125 4.6875 40 4.6875 27.45C4.6875 14.9 14.8875 4.675 27.45 4.675C40.0125 4.675 50.2125 14.8875 50.2125 27.4375C50.2125 39.9875 40 50.2125 27.45 50.2125Z",
    fill: "#47ADB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3375 9.41251C27.7625 9.16251 27.1125 9.16251 26.5375 9.41251C26.5375 9.41251 10.4875 16.325 10.4125 16.3625L27.425 23.925L44.4375 16.3625C44.4 16.325 28.3375 9.41251 28.3375 9.41251Z",
    fill: "#002C3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.22498 18.3375V36.55C9.22498 37.4625 9.76248 38.2875 10.6 38.65L26.3 45.6625V25.9125L9.23748 18.325L9.22498 18.3375Z",
    fill: "#002C3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6625 36.55V18.3375V18.325L28.5875 25.9125V45.6625L44.2875 38.65C45.1125 38.2875 45.6625 37.4625 45.6625 36.55Z",
    fill: "#002C3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8 51.75L54.1 44.0625C53.625 43.6 52.975 43.375 52.3125 43.45C50.0125 47.0125 46.9875 50.0375 43.4375 52.325C43.3625 52.9875 43.5875 53.6375 44.05 54.1125L51.75 61.8C53.075 63.1375 54.8875 63.8875 56.775 63.875C58.675 63.875 60.4625 63.1375 61.8 61.8C64.5625 59.0125 64.5625 54.525 61.8 51.75Z",
    fill: "#002C3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_279_3543"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetAutomatedBasedOrderStatus);
export default __webpack_public_path__ + "static/media/GetAutomatedBasedOrderStatus.92791da7b1932cada9cef0627382be5a.svg";
export { ForwardRef as ReactComponent };